import type { ICheckoutContext } from '@/types/context';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import { stripeService } from '@/services/stripe';
import { buildStripeLinkPaymentParams } from '@/utils/link';
import type { LinkPayPaymentParams } from '@/types/paymentHandlers';

const handleStripeLinkPay = async (
  _checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params: LinkPayPaymentParams,
  paymentMethodSettings: NonNullable<ReturnType<ICheckoutContext['paymentMethodsSettings']['find']>>
): Promise<unknown> => {
  const { event, elements } = params;

  const {
    id,
    card,
    billing_details: { email },
  } = await stripeService.createLinkPaymentMethod(elements, event.billingDetails);

  if (card && id) {
    return await sendPaymentToServer(buildStripeLinkPaymentParams(card, paymentMethodSettings, event, email!, id));
  }
};

export const handleLinkPayPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params?: LinkPayPaymentParams
): Promise<unknown> => {
  if (!params) {
    throw new Error('Link Pay payment requires event and elements parameters');
  }

  const paymentMethodSettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.LINK
  );

  if (!paymentMethodSettings) {
    throw new Error('Link Pay payment method settings not found');
  }

  if (!checkout.stripe) {
    throw new Error('Stripe instance not initialized');
  }

  switch (paymentMethodSettings.provider) {
    case ProviderEnum.STRIPE:
      return await handleStripeLinkPay(checkout, sendPaymentToServer, params, paymentMethodSettings);
      break;
    default:
      throw new Error(`Unsupported provider for Link Pay: ${paymentMethodSettings.provider}`);
  }
};
